// src/pages/TplinkSmartHubs.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TplinkSmartHubs() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>TP-Link Smart Hubs | SeguraTech</title>
        <meta
          name="description"
          content="Explore TP-Link’s smart home hubs — H100, H200, and H500 — designed for Matter-ready, Sub-1 GHz, and local automation within the Tapo ecosystem."
        />
        <meta property="og:title" content="TP-Link Smart Hubs | SeguraTech" />
        <meta
          property="og:description"
          content="TP-Link smart hubs coordinate your Tapo devices using Sub-1 GHz and Matter technologies — responsive, reliable, and secure."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seguratech.co.uk/tplink/smart-hubs" />
        <meta property="og:image" content="/tplink-logo.png" />
      </Helmet>

      {/* Hero */}
      <section className="max-w-5xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-6">
          TP-Link Smart Hubs
        </h1>
        <p className="text-lg text-white/80 max-w-3xl mx-auto">
          The TP-Link hub lineup connects and manages your smart home using
          reliable Sub-1 GHz communication and Matter-ready integration —
          enabling fast response times, local control, and strong reliability.
        </p>
      </section>

      {/* Hub Models */}
      <section className="max-w-6xl mx-auto px-4 pb-24 grid md:grid-cols-3 gap-10">
        {[
          {
            model: "H100",
            desc: "Compact hub for smaller Tapo installations. Uses Sub-1 GHz communication for sensors and switches, ensuring low power use and stable connections.",
          },
          {
            model: "H200",
            desc: "Sub 1 GHz and IP based devices. Enables smart automations, video with local storage upto 512gb, and seamless integration.",
          },
          {
            model: "H500",
            desc: "Flagship hub with Ethernet and Wi-Fi connectivity. Acts as a central Matter controller with Sub-1 GHz support for large multi-device smart homes, built in 16gb eMMC storage, expandable to 16gb ",
          },
        ].map((hub) => (
          <div
            key={hub.model}
            className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition text-center"
          >
            <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">
              {hub.model}
            </h3>
            <p className="text-white/80">{hub.desc}</p>
          </div>
        ))}
      </section>

      {/* Back */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
